import { Menu } from "@mantine/core";
import React from "react";
import { RiMoreFill } from "react-icons/ri";

const TableMenu = ({ items, width }) => {
  let finalItems = items.filter((x) => x.hasAccess);

  // please dont use button as items
  if (finalItems?.length > 0) {
    return (
      <>
        <Menu
          shadow="xl"
          position="bottom"
          withArrow
          width={width || 150}
          arrowPosition="center"
          offset={1}
          arrowSize={10}
        >
          <Menu.Target>
            <button>
              <RiMoreFill size={18} />
            </button>
          </Menu.Target>
          <Menu.Dropdown>
            {finalItems.map((item, menuIndex) => (
              <Menu.Item key={`${menuIndex}-TableMenu`} onClick={item?.onClick}>
                <div> {item?.jsx}</div>
              </Menu.Item>
            ))}
          </Menu.Dropdown>
        </Menu>
      </>
    );
  }

  return <>-</>;
};

export default TableMenu;
